module.exports = __webpack_public_path__ + "image/header_logo8.png";